import { isObject } from "@vueuse/core";
import { AppException } from "./exception";

type BaseValue = string | number | null | undefined;

export const validatorRule = {
    required: (value: BaseValue, error: string) => {
        if (!value) {
            throw new AppException(error);
        }
    },
    mobile: (value: BaseValue, error: string) => {
        if (value && !/^1[3-9]\d{9}$/.test(String(value))) {
            throw new AppException(error);
        }
    },
    email: (value: BaseValue, error: string) => {
        if (!String(value).includes('@')) {
            throw new AppException(error);
        }
    },
} as const;

type BuildRange<
  Start extends number,
  End extends number,
  Result extends number[] = [],
  Accumulated extends number[] = []
> = Result['length'] extends End
  ? Start | Accumulated[number]
  : BuildRange<Start, End, [...Result, 1], [...Accumulated, Start | (Accumulated['length'] extends never ? 0 : Accumulated['length'])]>;

type Rule = [
    (keyof typeof validatorRule) 
    | `min:${BuildRange<0, 999>}`
    | `max:${BuildRange<0, 999>}`,
    string,
];

type Rules<T extends object> = {
    [key in (keyof T)]?: Array<Rule>;
}

export async function validator<T>(model: T, rules: T extends object ? Rules<T> : Array<Rule>) {
    const valid = (value: unknown, rule: Array<Rule>) => {
        for (const r of rule) {
            if (r[0].startsWith('min:')) {
                const key = r[0] as string;
                const [, len] = key.split(':');
                if (String(value).length < Number(len)) {
                    throw new AppException(r[1]);
                }
            } else if (r[0].startsWith('max:')) {
                const key = r[0] as string;
                const [, len] = key.split(':');
                if (String(value).length > Number(len)) {
                    throw new AppException(r[1] as string);
                }
                
            } else {
                (validatorRule as any)[r[0]](value as BaseValue, r[1]);
            }
        }
    };
    if (isObject(model) && isObject(rules)) {
        for (const key in model) {
            const k = key as keyof T;
            const item  = model[k];
            const rule = (rules as Rules<T extends object ? T : never>)[k];
            rule && valid(item, rule);
        }
    } else if(!isObject(rules)) {
        valid(model, rules);
    } else {
        throw new AppException('调用异常');
    }
}